import type { ActionFunction } from '~/types/route-args';
import type { SetProjectInLibraryMutationVariables } from 'generated/graphql';
import { setProjectInLibrary } from '~/modules/directory/api/set-project-in-library.server';
import { z } from 'zod';
import * as zfd from 'zod-form-data';
import { UserErrorResponse } from '~/modules/root/graphql/responses';

const SetProjectInLibraryInputSchema = z.object({
    projectID: zfd.numeric(z.number()),
    // The hook submits the boolean via `fetcher.submit({ inLibrary })` which
    // serialises to the string 'true' or 'false' — coerce at the schema level
    // so the action body can treat it as a boolean directly.
    inLibrary: z.enum(['true', 'false']).transform((v) => v === 'true'),
});

export const action: ActionFunction = async ({ request, context }) => {
    const formData = await request.formData();
    const zfdFormData = zfd.formData(SetProjectInLibraryInputSchema);
    const zfdResult = zfdFormData.safeParse(formData);
    if (!zfdResult.success) {
        throw new UserErrorResponse(zfdResult.error);
    }
    const variables: SetProjectInLibraryMutationVariables = {
        ProjectID: zfdResult.data.projectID,
        InLibrary: zfdResult.data.inLibrary,
    };

    return await setProjectInLibrary({
        ...context,
        ...variables,
    });
};

export const SET_PROJECT_IN_LIBRARY =
    '/remix-api/directory/set-project-in-library';
